export const apiConfig = {
  // 独立维护 chat 模块的 baseURL
  baseUrl:'https://api-spectra.duplik.cn',
  apiKey: 'sk-NFjfdJRpgUrCXzUmJG1bKRFUTRsR9hx3',
  conversationsEndpoint: '/v1/conversations',
  createConversationEndpoint: '/v1/conversations/create',
  messagesEndpoint: '/v1/conversations/{conversation_id}/messages',
  defaultPageSize: 10,
  useMock: false // 融合方案中默认为 false，走真实接口
}